
import {
  defineComponent, ref, watch,
} from 'vue';
import { CardRatingItem, CardRating } from '@/components/listCard';
import { rateClient } from '@/apis';
import { useFetchListData, useScrollToBottom } from '@/composables';

export default defineComponent({
  components: {
    CardRating,
  },
  props: {
    /** 当前是否激活 */
    active: { type: Boolean, default: false },
  },
  setup(props) {
    const items = ref<CardRatingItem[]>([]);
    const enable = ref<boolean>(true);
    const {
      fetching, fetchingMore, fetchList, fetchMore,
    } = useFetchListData(
      async () => rateClient
        .getRatingList({ limit: 20 }).then(({ data }) => {
          items.value = data;
        }),
      async () => rateClient
        .getRatingList({
          lastId: items.value[items.value.length - 1].id,
          limit: 20,
        })
        .then(({ data }) => {
          items.value = [...items.value, ...data];
          if (data.length === 0) {
            enable.value = false;
          }
        }),
    );

    watch(() => props.active, (value) => {
      // activeTab 改变时，若当前 tab 无数据则重新拉数据
      if (value && !items.value.length) {
        fetchList();
      }
    });

    // 首次进入该页面且 active 时拉数据
    if (props.active) {
      fetchList();
    }

    // 滚动到底部时拉新数据
    const { scrollRef: scroll } = useScrollToBottom(
      () => fetchMore(),
      500,
      enable,
    );

    return {
      items,
      scroll,
      fetching,
      fetchingMore,
    };
  },
});
